import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { ImageField } from "./ImageField";
import { GalleryField } from "./GalleryField";

const base = "bg-black/40 border-white/10 text-white";

export const Field = ({ f, value, onChange }) => {
  if (f.type === "textarea")
    return <Textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={4} className={base} data-testid={`field-${f.key}`} />;
  if (f.type === "boolean")
    return <div className="pt-1"><Switch checked={!!value} onCheckedChange={onChange} data-testid={`field-${f.key}`} /></div>;
  if (f.type === "select")
    return (
      <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={`field-${f.key}`}
        className="w-full h-10 rounded-md bg-black/40 border border-white/10 text-white px-3 text-sm">
        <option value="">—</option>
        {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  if (f.type === "image")
    return <ImageField value={value} onChange={onChange} testid={`field-${f.key}`} />;
  if (f.type === "gallery")
    return <GalleryField value={value} onChange={onChange} testid={`field-${f.key}`} />;
  if (f.type === "tags") {
    const str = Array.isArray(value) ? value.join(", ") : (value ?? "");
    return <Input value={str} onChange={(e) => onChange(e.target.value)} placeholder="comma, separated" className={base} data-testid={`field-${f.key}`} />;
  }
  return <Input type={f.type === "number" ? "number" : "text"} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={base} data-testid={`field-${f.key}`} />;
};

export const buildPayload = (fields, form) => {
  const payload = { ...form };
  fields.forEach((f) => {
    if (f.type === "number") payload[f.key] = form[f.key] === "" || form[f.key] == null ? null : Number(form[f.key]);
    else if (f.type === "boolean") payload[f.key] = !!form[f.key];
    else if (f.type === "tags") {
      const v = form[f.key];
      payload[f.key] = Array.isArray(v) ? v : String(v || "").split(",").map((s) => s.trim()).filter(Boolean);
    }
  });
  return payload;
};

export const FieldRow = ({ f, value, onChange }) => (
  <div className={f.type === "textarea" || f.type === "gallery" ? "sm:col-span-2" : ""}>
    <label className="text-[11px] font-mono uppercase tracking-widest text-slate-400 mb-1.5 block">
      {f.label}{f.required && <span className="text-rose-400"> *</span>}
    </label>
    <Field f={f} value={value} onChange={onChange} />
  </div>
);
